import {
    MOD_CHECKOUT,
    MOD_CONFIGURATOR,
    MOD_FORM_MANAGER,
    MOD_SETTINGS,
    MOD_SWATCH_MANAGER,
    registerVuexModules
} from '@/appManager/vuexModules';
import {registerVueComponents} from "@/appManager/componentRegistry";
import {ensureModule} from "@/appManager/store";

/**
 * Central bootstrap pipeline
 */
export async function bootstrapApp() {

    import('@/vue/filters/price_formats');
    import('@/vue/components/form/filters_form');


    // Vuex modules must be registered first
    registerVuexModules();

    // preload Vuex modules -> needed by some Vue Modules
    await ensureModule(MOD_SETTINGS);
    await ensureModule(MOD_FORM_MANAGER);
    await ensureModule(MOD_CONFIGURATOR);
    await ensureModule(MOD_CHECKOUT);
    await ensureModule(MOD_SWATCH_MANAGER);

    // await resolveDOMFeatures();
    registerVueComponents();
}
